<!-- 存款演示 -->
<template>
    <div class="DepositDemo">
        <div class="titleBOx">
               <h2 class="title">
                {{help.name16}}
            </h2>
        </div>
        <div class="content"> 
            <div class="box">
                <h5 class="tip4">一：点击【资金】-【会员存款】</h5>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/deposit1.jpg')" alt="">
                <h5 class="tip4">1：公司入款</h5>
                <p class="tip2">选择银行：选择我司收款银行</p>
                <p class="tip2">存款姓名：填入转账方姓名：张三</p>
                <p class="tip2">充值金额：填入要充值的金额如：501.2（建议尾数不为0或带小数）</p>
                <p class="tip2 tip5">点击【下一步】</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/deposit2.jpg')" alt="">
                <p class="tip2">复制所需的收款信息进行转账，点击文本图标可进行复制，转账成功到账后，等待财务为您添加处理。</p>
                <p class="tip2 tip5">可使用以下转账方式：网银转账、银联转账、支付宝转卡</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/deposit3.jpg')" alt="">
                <h5 class="tip4">1：线上入款</h5>
                <p class="tip2">充值通道-【手机银行网银转账卡】或【网银100-10000】</p>
                <p class="tip2">充值金额：填入要充值的金额如：1234.5（建议尾数不为0或带小数）</p>
                <p class="tip2 tip5">点击【下一步】</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/deposit4.jpg')" alt="">
                <p class="tip2 tip5">复制所需的收款信息进行转账，转账成功到账后，自动添加彩金。</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/deposit5.jpg')" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            index:0
        }
    },
     computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .DepositDemo{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .box{
                width: 100%;
                .list{
                    display: inline-block;
                    width: 116px;
                    height: 42px;
                    background: #d9d9d9;
                    color: #000;
                    line-height: 45px;
                    font-size: 14px;
                    overflow: hidden;
                    margin-bottom: 30px;
                    margin-top: 10px;
                    margin-right: 10px;
                    font-weight: 600;
                    cursor: pointer;
                    text-indent: 0;
                    text-align: center;
                }
                .activity{
                    background: #000;
                    color: #fff;
                }
                img{
                    width: 100%;
                    margin-bottom: 10px;
                }
                .tip1 {
                    padding: 15px 0 20px;
                    font-size: 18px;
                    font-weight: 500;
                    line-height: 30px;
                }
                .tip4 {
                    font-size: 15px;
                    padding: 0 0 10px;
                }
                .tip2 {
                    line-height: 28px;
                    font-size: 14px;
                    color: #666;
                }
                .tip5 {
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>